module.exports = __webpack_public_path__ + "img/frog.30177d7d.png";